<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg fill="currentColor" viewBox="-4.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.89 16.907a.554.554 0 0 1-.553.554H1.663a.554.554 0 0 1 0-1.108h2.783V14.88a4.157 4.157 0 0 1-3.007-.89 4.343 4.343 0 0 1-.878-3.162 4.343 4.343 0 0 1 3.163.877 2.953 2.953 0 0 1 .722 1.313V9.77A2.426 2.426 0 1 1 1.65 5.806a2.426 2.426 0 1 1 3.37-3.37 2.426 2.426 0 1 1 3.369 3.37 2.45 2.45 0 0 1 .353.292A2.426 2.426 0 0 1 5.554 9.74v4.055a2.952 2.952 0 0 1 .722-1.312 4.343 4.343 0 0 1 3.163-.878 4.343 4.343 0 0 1-.878 3.162 4.156 4.156 0 0 1-3.007.89v.696h2.783a.554.554 0 0 1 .554.554zM5.019 7.231a1.425 1.425 0 1 0-1.425-1.425A1.425 1.425 0 0 0 5.018 7.23z"
		></path>
	</svg>
</div>
